var mentions_default = {
  "mention": "ouD4p",
  "mentionViewer": "zPQLA",
  "cursorDefault": "SJeqR",
  "cursorPointer": "uPNkw"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
